import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=4b56ab38&scoped=true"
import script from "./GlobalMessage.vue?vue&type=script&lang=js"
export * from "./GlobalMessage.vue?vue&type=script&lang=js"
import style0 from "./GlobalMessage.vue?vue&type=style&index=0&id=4b56ab38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56ab38",
  null
  
)

export default component.exports